import {useHistory, useLocation} from 'react-router-dom'
import {Backdrop, Box, CircularProgress, CssBaseline, Grid} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import {Alert, AlertTitle} from '@material-ui/lab'
import React, {useState} from 'react'
import {IRegisterRequestParams} from '../../interfaces/api'
import {register, validate} from '../../services/api'
import AccountForm from './AccountForm'
import UserInfoForm from './UserInfoForm'
import Intro from './RegInfo'
import data from './data.json'
import NextButton from '../Common/NextButton'
import queryString from "querystring";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#F7FBFF",
        padding: '2vh 5vw',
        minHeight: '40vh',
    },
    layout: {
        width: 'auto',
        height: '100%',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingBottom: theme.spacing(3),
        },
        overflow: 'visible',
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
    },
    stepper: {
        padding: theme.spacing(3, 0, 5),
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
}))

const validTypes = ['password', 'phone', 'email', 'amount', 'state', 'zip']

export default function UserRegistration() {
    const history = useHistory()

    const {search} = useLocation()
    let qs = queryString.parse(search.substring(1))
    search.split("&").forEach(item => {
        const fv = item.split("=")
        if (fv[0] === "email") {
            qs[fv[0]] = decodeURIComponent(fv[1]).replace(' ', '+');
        }
    })
    console.log(qs.email)
    const classes = useStyles()
    const [activeStep, setActiveStep] = useState(0)
    const [errors, setErrors] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [userInfo, setUserInfo] = useState<IRegisterRequestParams>({
        nickName: qs.first_name || "",
        firstName: qs.first_name || "",
        lastName: qs.last_name || "",
        email: qs.email || "",
        password: '',
        passwordConfirmation: '',
        phone: qs.phone || "",
        dateOfBirth: qs.dob || "",
        emergencyContactName: qs.emergency_contact_name || "",
        emergencyContactPhone: qs.emergency_contact_phone || "",
        referral_id: qs.referral_id || "",
        referral_name: qs.referral_name || "",
    })

    const handleFirst = async () => {
        const currentUserInfo = userInfo
        setUserInfo({
            ...currentUserInfo,
        })
        if (activeStep === 1 && (userInfo.password === '' || userInfo.passwordConfirmation === '')) {

            setErrors(() => {
                return ['Password is required']
            })
            return
        }
        if (activeStep > 2) {
            setActiveStep(1)
        } else {
            setActiveStep(activeStep + 1)
        }
    }
    const handleNext = async () => {
        let errors = await handleValidation()
        if (errors?.length > 0) {
            window.scrollTo(0, 0)
            return
        }
        const currentUserInfo = userInfo
        setUserInfo({
            ...currentUserInfo,
        })
        if (activeStep === 1 && (userInfo.password === '' || userInfo.passwordConfirmation === '')) {

            setErrors(() => {
                return ['Password is required']
            })
            return
        }
        if (activeStep > 2) {
            setActiveStep(1)
        } else {
            setActiveStep(activeStep + 1)
        }
    }
    const handleNextNoPhone = async () => {
        let errors = await handleValidationNoPhone()
        if (errors?.length > 0) {
            window.scrollTo(0, 0)
            return
        }
        const currentUserInfo = userInfo
        setUserInfo({
            ...currentUserInfo,
        })
        if (activeStep === 1 && (userInfo.password === '' || userInfo.passwordConfirmation === '')) {

            setErrors(() => {
                return ['Password is required']
            })
            return
        }
        if (activeStep > 2) {
            setActiveStep(1)
        } else {
            setActiveStep(activeStep + 1)
        }
    }
    const handlePrev = () => {
        setErrors([])
        if (activeStep < 2) {
            history.push('/welcome')
        }
        setActiveStep(activeStep - 1)
    }

    const handleSubmit = async () => {
        const currentUserInfo = userInfo
        if (errors.length > 0) {
            setUserInfo(currentUserInfo)
        }
        setLoading(true)

        const response = await register(userInfo)
        if (response.data.errors) {
            setLoading(false)
            let errors = response.data.errors && Array.isArray(response.data.errors) ?
                response.data.errors.map((error: any, idx: number) => (<span key={idx}>{error.message}<br/></span>)) :
                response.data.message
            setErrors(errors)
            window.scrollTo(0, 0)
            return
        } else {
            sessionStorage.setItem('token', response.data.token)
            sessionStorage.setItem('expires', response.data.expires)
            sessionStorage.setItem('sessionId', response.data.sessionId)
        }
        setLoading(false)

        history.push('/confirmation')
    }

    const handleValidation = async () => {

        const fields = filterToValidatableFields(userInfo)

        if (fields.length > 0) {
            setLoading(true)
            const response = await validate({
                fields,
            })
            const results = response.data?.fields

            if (!!results.length) {
                let validResults = results
                    .filter((item: any) => {
                        return item.valid !== true
                    })
                    .map((item: any, idx: number) => {
                        return <span key={idx}>{item.message}<br/></span>
                    })
                if (userInfo.passwordConfirmation !== "" && userInfo.password !== userInfo.passwordConfirmation) {
                    validResults.push(<span
                        key="nomatch">The password confirmation didn't match the password.<br/></span>)
                }
                setErrors(validResults)
                setLoading(false)
                return validResults
            }
            setLoading(false)

        }
    }
    const handleValidationNoPhone = async () => {

        const fields = filterToValidatableFields(userInfo)

        if (fields.length > 0) {
            setLoading(true)
            const response = await validate({
                fields: fields.filter(f => f.id !== 'phone'),
            })
            const results = response.data?.fields

            if (!!results.length) {
                let validResults = results
                    .filter((item: any) => {
                        return item.valid !== true
                    })
                    .map((item: any, idx: number) => {
                        return <span key={idx}>{item.message}<br/></span>
                    })
                if (userInfo.passwordConfirmation !== "" && userInfo.password !== userInfo.passwordConfirmation) {
                    validResults.push(<span
                        key="nomatch">The password confirmation didn't match the password.<br/></span>)
                }
                setErrors(validResults)
                setLoading(false)
                return validResults
            }
            setLoading(false)

        }
    }
    const filterToValidatableFields = (rawFields: any) => {
        console.log(rawFields)
        const fields = Object.entries(rawFields).map(([key, value]) => {
            //TODO Refactor below
            return {
                id: key,
                type: validTypes.filter((type) =>
                    key.toLowerCase().includes(type.toLowerCase())
                )[0],
                value,
            }
        })
        return fields.filter((item) => {
            return item.type !== undefined && item.value !== ''
        })
    }

    const getContent = () => {
        switch (activeStep) {
            case 0:
                return (
                    <React.Fragment>
                        <Intro
                            screens={data}
                            handleNext={handleFirst}
                            handlePrev={handlePrev}
                        />
                    </React.Fragment>
                )

            case 1:
                return (
                    <React.Fragment>
                        <AccountForm
                            userInfo={userInfo}
                            setUserInfo={setUserInfo}
                            handleNext={handleNextNoPhone}
                            handlePrev={handlePrev}
                            handleValidation={handleValidation}
                            errors={errors}
                            setErrors={setErrors}
                        />
                    </React.Fragment>
                )

            case 2:
                return (
                    <React.Fragment>
                        <UserInfoForm
                            userInfo={userInfo}
                            setUserInfo={setUserInfo}
                            handleNext={handleNext}
                            handlePrev={handlePrev}
                            handleSubmit={handleSubmit}
                            handleValidation={handleValidation}
                            errors={errors}
                            setErrors={setErrors}
                        />
                    </React.Fragment>
                )
            default:
                return (
                    <React.Fragment>
                        <AccountForm
                            userInfo={userInfo}
                            setUserInfo={setUserInfo}
                            handleNext={handleNext}
                            handlePrev={handlePrev}
                            handleValidation={handleValidation}
                            errors={errors}
                            setErrors={setErrors}
                        />
                        <NextButton handleClick={handleSubmit}/>
                    </React.Fragment>
                )
        }
    }

    return (
        <React.Fragment>

            <CssBaseline/>
            {/*<Box className={classes.root}>*/}
            {/*  <Grid item>*/}
            {/*    <main className={classes.layout}>*/}
            <React.Fragment>
                {errors.length ? (
                    <Alert severity="error">
                        <AlertTitle>Error</AlertTitle>
                        {errors}
                    </Alert>
                ) : null}

                <style dangerouslySetInnerHTML={{
                    __html: [
                        '\n' +
                        'div.MuiDialog-root .MuiTypography-body1 {\n' +
                        '  font-size: 16px !important;\n' +
                        '}'
                    ].join('\n'),
                }}/>
                <React.Fragment>

                    <Backdrop
                        style={{zIndex: 100}}
                        sx={(theme) => ({ color: '#fff', zIndex: 100 })}
                        open={loading}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    {getContent()}
                </React.Fragment>
            </React.Fragment>
            {/*</main>*/}
            {/*</Grid>*/}
            {/*</Box>*/}
        </React.Fragment>
    )
}
